import type { App } from 'vue'

import { vTooltip } from './tooltip'

/** Registers what the kit needs app-wide (called by src/app/main.ts after the theme). */
export function installKit(app: App): void {
  app.directive('tooltip', vTooltip)
}
